module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 section",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Professionally, Colin Graham has been a teacher, a head teacher, a part-time lecturer in teacher training and a field teacher for the RSPB. During that time, he told this story to many groups of children who always appeared transfixed by each instalment. Their empathy with miniaturised children was always apparent, so he finally decided to put "), _c('em', [_vm._v("The Shrinking")]), _vm._v(" into writing. Colin is now a trustee of The Barnsley Biodiversity Trust and project leader of Biodiversity in Schools. He visits schools on a regular basis and his knowledge of and empathy with children is vast. His wildlife knowledge is also formidable.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2486c48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch001.vue
// module id = 63
// module chunks = 0